import React from "react";
import { StyledLoader } from "./Loader.styled";
import { Spacing } from "../../theme/wscTheme.types";

interface Props {
  size: Spacing;
}

export default function Loader({ size }: Props) {
  return <StyledLoader size={size} aria-label="Loading..."></StyledLoader>;
}
